// import API from "../api/axios";

// // ─── Get All Leads ───
// export const getLeads = (page = 1, filters = {}) => {
//    let url = `/leads?page=${page}&limit=10`;
//    if (filters.status) url += `&status=${encodeURIComponent(filters.status)}`;
//    if (filters.project_id) url += `&project_id=${filters.project_id}`;
//    if (filters.search) url += `&search=${encodeURIComponent(filters.search)}`;
//    if (filters.assigned === "unassigned") url += `&assigned=unassigned`;
//    return API.get(url);
// };

// // ─── Get Single Lead ───
// export const getLead = (id) => {
//    return API.get(`/leads/${id}`);
// };

// // ─── Create Lead ───
// export const createLead = (data) => {
//    return API.post("/leads", data);
// };

// // ─── Update Lead ───
// export const updateLead = (id, data) => {
//    return API.put(`/leads/${id}`, data);
// };

// // ─── Delete Lead ───
// export const deleteLead = (id) => {
//    return API.delete(`/leads/${id}`);
// };

// // ─── Import Leads ───
// export const importLeads = (formData) => {
//    return API.post("/leads/import", formData);
// };

// // ─── Export Leads ───
// export const exportLeads = () => {
//    return API.get("/leads/export", { responseType: "blob" });
// };

// // ─── Convert Lead to Sale ───
// export const convertLead = (id, data) => {
//    return API.post(`/leads/${id}/convert`, data);
// };

// // ─── Bulk Assign Leads ───
// export const bulkAssignLeads = (data) => {
//    return API.post("/leads/bulk-assign", data);
// };

// // ─── Get Projects ───
// export const getProjects = () => {
//    return API.get("/projects");
// };

// // ─── Create Project ───
// export const createProject = (data) => {
//    return API.post("/projects", data);
// };

// // ─── Get Users List ───
// export const getUsersList = () => {
//    return API.get("/users");
// };

import API from "../api/axios";

// ─── Get All Leads ───
export const getLeads = (params) => {
   return API.get("/leads", { params });
};

// ─── Create Lead ───
export const createLead = (data) => {
   return API.post("/leads", data);
};

// ─── Update Lead ───
export const updateLead = (id, data) => {
   return API.put(`/leads/${id}`, data);
};

// ─── Delete Lead ───
export const deleteLead = (id) => {
   return API.delete(`/leads/${id}`);
};

// ─── Import Leads ───
export const importLeads = (formData) => {
   return API.post("/leads/import", formData);
};

// ─── Export Leads ───
// export const exportLeads = () => {
//    return API.get("/leads/export", { responseType: "blob" });
// };
export const exportLeads = (params) => {
   return API.get("/leads/export", { params, responseType: "blob" });
};

// ─── Convert Lead to Sale ───
export const convertLead = (id, data) => {
   return API.post(`/leads/${id}/convert`, data);
};

// ─── Bulk Assign Leads ───
export const bulkAssignLeads = (data) => {
   return API.post("/leads/bulk-assign", data);
};

// ─── Get Projects ───
export const getProjects = () => {
   return API.get("/projects");
};

// ─── Create Project ───
export const createProject = (data) => {
   return API.post("/projects", data);
};

// ─── Get Users List ───
export const getUsersList = () => {
   return API.get("/users");
};